export default {
    methods: {
        meta: function (type, col) {
            return this[type][col] ? this[type][col] : null;
        }
    },
    data: function () {
        return {
            archival_collection: {
                'title': 'name',
                'custom_creator': 'creator',
                'scope': 'description',
                'history': 'description',
                'inc_dte': 'temporalCoverage',
                'language': 'language',
                'custom_subject': 'keywords',
                'sub_form': 'genre',
                'custom_accession_number': 'identifier',
                'custom_record_date': 'dateModified'
            },

            archival_series: {
                'title': 'name',
                'author': 'creator',
                'language': 'language',
                'scope': 'description',
                'restric': 'description',
                'inc_dte': 'temporalCoverage',
                'bulk_dte': 'temporalCoverage',
                'contents': 'text',
                'custom_other_terms': 'keywords',
                'custom_subject': 'keywords',
                'custom_genre_form': 'genre',
                'custom_accession_number': 'identifier',
                'custom_record_date': 'dateModified'
            },

            archival_fileunit: {
                'title': 'name',
                'author': 'creator',
                'edition': 'description',
                'categ_16': 'description',
                'categ_9': 'description',
                'categ_4': 'language',
                'categ_3': 'text',
                'custom_other_terms': 'keywords',
                'custom_subject': 'keywords',
                'custom_genre_form': 'genre',
                'custom_accession_number': 'identifier',
                'custom_record_date': 'dateModified'
            },

            archival_item: {
                'title': 'name',
                'author': 'creator',
                'edition': 'description',
                'notes': 'description',
                'categ_16': 'description',
                'categ_9': 'description',
                'categ_4': 'language',
                'categ_3': 'text',
                'custom_other_terms': 'keywords',
                'custom_subject': 'keywords',
                'custom_genre_form': 'genre',
                'custom_accession_number': 'identifier',
                'custom_record_date': 'dateModified'
            },

            library: {
                'title': 'name',
                'author': 'author',
                'publisher': 'publisher',
                'notes': 'comments',
                'item_desc': 'description',
                'custom_genre_form': 'genre',
                'custom_other_terms': 'keywords',
                'custom_subject': 'about',
                'edition': 'edition',
                'categ_3': 'text',
                'categ_17': 'alternateName',
                'custom_accession_number': 'identifier',
                'custom_record_date': 'dateModified'
            },

            vessel: {
                'title': 'name',
                'gen_desc': 'description',
                'gen_fld1': 'bodyType',
                'gen_fld2': 'homeLocation',
                'gen_fld3': 'vehicleIdentificationNumber',
                'gen_fld4': 'productionDate',
                'gen_fld5': 'locationCreated',
                'gen_fld7': 'manufacturer',
                'gen_fld12': 'comments',
                'custom_accession_number': 'identifier',
                'custom_record_date': 'dateModified'
            },

            mariners_collection: {
                'title': 'name',
                'artist': 'creator',
                'intr_mem': 'description',
                'description': 'description',
                'categ_12': 'text',
                'categ_16': 'dateCreated',
                'obj_mem': 'keywords',
                'maker': 'locationCreated',
                'custom_material': 'material',
                'custom_place': 'locationCreated',
                'custom_accession_number': 'identifier',
                'custom_record_date': 'dateModified'
            },

            monitor_collection: {
                'title': 'name',
                'artist': 'creator',
                'intr_mem': 'description',
                'description': 'description',
                'categ_12': 'text',
                'categ_16': 'dateCreated',
                'obj_mem': 'keywords',
                'maker': 'locationCreated',
                'custom_material': 'material',
                'custom_place': 'locationCreated',
                'custom_accession_number': 'identifier',
                'custom_record_date': 'dateModified'
            },

            exhibit: {
                'title': 'name',
                'start_dte': 'startDate',
                'end_dte': 'endDate',
                'exhibt_id': 'identifier',
                'exhibt_mem': 'about',
                'exb_sta': 'eventStatus',
                'custom_record_date': 'dateModified'
            },

            association: { // association meta is put in meta tags on page
                'association_name': 'name',
                'association_id': 'identifier',
            },
        }
    }
}
